import routes from "components/routes";

export const PAYMENT_TYPE = {
  INSURANCE_PREMIUM: [
    "Health Insurance Premium",
    "Personal Accident Premium",
    "Term Life Premium",
    "GHI Premium",
    "GPA Premium",
    "GTL Premium",
    "Health Checkup Premium",
    "OPD Cover Premium",
    "Critical Illness Premium",
    "Mandatory Top Up Health",
    "Top Up Health",
  ],
};

export const PAYMENT_STATUS = {
  REFUNDED: "Refunded",
  PAID: "Paid",
};

export const INSURANCE_PRODUCTS = [
  "Group Health Insurance",
  "Group Personal Accident",
  "Group Term Life",
];

export const FLEX_PRODUCTS = {
  health_insurance: "Group Mediclaim Cover",
  health_insurance_additional: "Group Mediclaim Cover (Additional)",
  personal_accident: "Group Personal Accident",
  term_life: "Group Term Life",
  opd_cover: "OPD Cover",
  critical_illness: "Critical Illness",
  health_checkup: "Health Checkup",
  mandatory_top_up_health: "Mandatory Top Up Health",
  top_up_health: "Top Up Health",
  parental_cover: "Parental Cover",
  health_insurance_parents: "Group Mediclaim Cover (Parents)",
  health_insurance_parents_in_laws: "Group Mediclaim Cover (Parents-In-Laws)",
};

export const ALL_PRODUCTS = {
  GMC: "Group Mediclaim Cover",
  GMC_M: "Group Mediclaim Cover",
  GPA: "Group Personal Accident",
  GTL: "Group Term Life",
  health_insurance: "Group Mediclaim Cover",
  health_insurance_additional: "Group Mediclaim Cover (Additional)",
  personal_accident: "Group Personal Accident",
  term_life: "Group Term Life",
  opd_cover: "OPD Cover",
  critical_illness: "Critical Illness",
  health_checkup: "Health Checkup",
  mandatory_top_up_health: "Mandatory Top Up Health",
  top_up_health: "Top Up Health",
  parental_cover: "Parental Cover",
  health_insurance_parents: "Group Mediclaim Cover (Parents)",
  health_insurance_parents_in_laws: "Group Mediclaim Cover (Parents-In-Laws)",
};

export const PRIORITY_ORDER = [
  "GMC",
  "GMC_M",
  "GPA",
  "GTL",
  "health_insurance",
  "health_insurance_additional",
  "personal_accident",
  "term_life",
  "mandatory_top_up_health",
  "top_up_health",
  "opd_cover",
  "critical_illness",
  "health_checkup",
  "parental_cover",
  "health_insurance_parents",
  "health_insurance_parents_in_laws",
];

export const CASHLESS_CLAIM_URLS = {
  NIVA: "https://transaction.nivabupa.com/Pages/hospitalnetwork.aspx",
  KOTAK:
    "https://www.kotakgeneral.com/Externalfiles/Kotak-Updated-Network-list_OCT-Mediassist.xlsx",
  ICICI: "https://www.icicilombard.com/cashless-hospitals",
  DIGIT: "https://www.medibuddy.in/networkHospitals",
  DEFAULT: "https://www.careinsurance.com/health-plan-network-hospitals.html",
};

export const UTILITIES = [
  {
    url: "/v1/utilities/client-id",
    title: "Client ID File Generator",
    subtitle:
      "Select your insurer, upload their file, and generate a standardized client ID file.",
  },
  {
    url: `/${routes.UTILITIES_UHID_GENERATOR}`,
    title: "Upload Files",
    subtitle:
      "Currently unavailable: Upload your file to receive a direct download link.",
    disabled: true,
  },
];

export const MENU_ITEMS = [
  {
    name: "Overview",
    path: "/v1",
    headerName: "Dashboard",
    subPaths: ["/v1/claim-support", "/v1/plan-overview/*"],
  },
  {
    name: "Cash Deposit Account",
    path: "/v1/cash-deposit",
    headerName: "Cash Deposit Account",
    role: "admin",
    subPaths: ["/v1/cash-deposit/transactions", "/v1/cash-deposit/update"],
  },
  {
    name: "Upload Policy Document",
    path: "/v1/upload-policy",
    headerName: "Policy Document",
    role: "admin",
  },
  {
    name: "Upload Enrolments",
    path: "/v1/enrolments/create",
    headerName: "Upload Enrolments",
    role: "admin",
  },
  {
    name: "Add/Delete Employees",
    path: "/v1/add-delete",
    headerName: "Add/Delete Employees",
  },
  {
    name: "Enrolment History",
    path: "/v1/enrolments",
    headerName: "Enrolment History",
  },
  {
    name: "Employee MIS",
    path: "/v1/employee-mis",
    headerName: "Employee MIS",
    subPaths: ["/v1/employee-mis/e-cards/*"],
  },
  {
    name: "Claims MIS",
    path: "/v1/claims",
    headerName: "Claims",
    subPaths: ["/v1/claims/mis", "/v1/claims/mis/*"],
  },
  {
    name: "Collect Employee Data",
    path: "/v1/data-collection-history/collect",
    headerName: "Collect Employee Data",
    role: "admin"
  },
  {
    name: "Data Collection History",
    path: "/v1/data-collection-history",
    headerName: "Data Collection History",
  },
  {
    name: "Wellness",
    path: "/v1/wellness",
    headerName: "Setup Health & Wellness Benefits",
    role: "admin",
  },
  {
    name: "Add Products",
    path: "/v1/products/add",
    headerName: "Products",
    role: "admin",
    // subPaths: ["/v1/claims/mis", "/v1/claims/mis/*"],
  },
  {
    name: "Company Profile",
    path: "/v1/profile/company/edit",
    headerName: "Company Profile",
  },
  {
    name: "Utilities",
    path: "/v1/utilities",
    headerName: "Utilities",
    role: "admin",
    subPaths: ["/v1/utilities/client-id"],
  },
];

export const PATHNAME_MAPPING = {
  "/v1": "Dashboard",
  "/v1/": "Dashboard",
  "/v1/grade-edit": "Edit Grade",
  "/v1/claim-support": "Dashboard",
  "/v1/enrolments": "Enrolment History",
  "/v1/enrolments/edit": "Edit Enrolment",
  "/v1/plan-overview/*": "Dashboard",
  "/v1/employee-mis": "Employee MIS",
  "/v1/employee-mis/e-cards/*": "Employee MIS",
  "/v1/claims": "Claims",
  "/v1/claims/mis": "Claims",
  "/v1/claims/mis/*": "Claims",
  "/v1/cash-deposit/transactions": "Transaction History",
  "/v1/utilities/client-id": "Client ID File Generator",
  "/v1/profile/company/*": "Company Profile",
  "/v1/profile/*": "My Profile",
  "/v1/cash-deposit/*": "Cash Deposit",
  "/v1/wellness/setup/summary": "Health & Wellness Benefits",
  "/v1/wellness/setup/summary-post/*": "Health & Wellness Benefits",
};

export const USER_PROFILE_PAGES = [
  // {
  //   name: "Company Profile",
  //   path: "/v1/profile/company/edit",
  // },
  {
    name: "Profile",
    path: "/v1/profile",
  },
  {
    name: "Logout",
    callback: () => {
      const role = localStorage.getItem("role");
      if (role && role === "admin") {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/";
      } else {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/corporate/login";
      }
    },
  },
];

export const ENROLMENT_HISTORY_COLUMNS = [
  "Product",
  "Type",
  "Status",
  "Total Employees",
  "Total Lives",
  "Payment Date",
  "Payment Amount",
  "Endorsement Number",
  "View Documents",
  ""
];
